const requireAll = (r) => r.keys().forEach(r);

try {
  requireAll(require.context('../../assets/svg/', true, /\.svg$/));
} catch (err) {
  throw new Error(`ERROR -> ${err}`);
}
const svgInject = (data) => {
  document.getElementById('svg-icons').innerHTML = data;
};
fetch(`/static/templates/${ENV.PROJECT_NAME}/dist/sprite.svg`)
  .then((res) => res.text())
  .then((data) => svgInject(data));
